(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.tagserve = {
    attach: function (context, settings) {
      $(document, context).once('tagserve').each(function () {
        // Check for "tagrid" url parameter
        const tagridValue = getUrlPrameter('tagrid');
        // If exists, set cookie - 30 days
        if (tagridValue) {
          const expDate = new Date();
          expDate.setTime(expDate.getTime() + (30 * 24 * 60 * 60 * 1000));
          document.cookie = `tagrid=${tagridValue}; expires=${expDate}; path=/; Domain=.valeholidayparks.com`;
        }
        return;
      });
    }
  };

  // Find parameter from url string
  function getUrlPrameter (param) {
    let tagridValue = '';
    const urlVars = window.location.search.substring(1).split('&');
    if (!urlVars) {
      return;
    }
    urlVars.forEach(urlVar => {
      let paramPair = urlVar.split('=');
      if (paramPair[0] === param) {
        tagridValue = paramPair[1];
      }
    });

    return tagridValue;
  }
})(window.Drupal, window.jQuery);
